import qs from 'qs';
import { csrfFromDom } from 'common/utils/server';
import _ from 'lodash';
import api from '../api';

const FETCH_CALIBRATION_SUCCESS = 'calibrationPage/FETCH_CALIBRATION_SUCCESS';
const FETCH_QUESTION_ANSWERS_SUCCESS =
  'calibrationPage/FETCH_QUESTION_ANSWERS_SUCCESS';
const UPDATE_SELECTED_OPTIONS = 'calibrationsPage/UPDATE_SELECTED_OPTIONS';
const CLEAR_CALIBRATION = 'calibrationsPage/CLEAR_CALIBRATION';

// Action Creators

const fetchCalibrationSuccess = calibration => ({
  type: FETCH_CALIBRATION_SUCCESS,
  calibration,
});

const fetchQuestionAnswersSuccess = answers => ({
  type: FETCH_QUESTION_ANSWERS_SUCCESS,
  answers,
});

const updateSelectedOptions = mapping => ({
  type: UPDATE_SELECTED_OPTIONS,
  mapping,
});

export const clearCalibration = () => ({
  type: CLEAR_CALIBRATION,
});

// Thunks

export const fetchCalibration = id => dispatch =>
  api
    .fetch(dispatch, `qa_calibrations/${id}`)
    .then(([json]) => dispatch(fetchCalibrationSuccess(json)));

export const deleteCalibration = id => dispatch =>
  api.fetch(dispatch, `qa_calibrations/${id}`, {
    method: 'DELETE',
    credentials: 'include',
    headers: {
      'Content-Type': 'application/json',
      'X-CSRF-token': csrfFromDom(),
    },
  });

export const fetchQuestionAnswers = (questionId, reviewIds) => dispatch => {
  const query = qs.stringify(
    {
      qa_question_id: questionId,
      qa_review_ids: reviewIds,
      product_area: 'qa_calibration',
    },
    { arrayFormat: 'brackets' }
  );

  return api
    .fetch(dispatch, `qa_answers/?${query}`)
    .then(([json]) => dispatch(fetchQuestionAnswersSuccess(json)));
};

export const saveOption = (calibrationId, optionId, questionId) => dispatch => {
  const naOption = _.startsWith(optionId, 'na') ? true : null;
  dispatch(updateSelectedOptions({ [questionId]: naOption ? null : optionId }));
  const url = `qa_calibrations/${calibrationId}/option`;
  return api
    .fetch(dispatch, url, {
      method: 'PUT',
      credentials: 'include',
      headers: {
        'Content-Type': 'application/json',
        'X-CSRF-token': csrfFromDom(),
      },
      body: JSON.stringify({
        qa_option_id: optionId,
        na_option: naOption,
        qa_question_id: questionId,
      }),
    })
    .then(([json]) => {
      dispatch(fetchCalibrationSuccess(json));
    });
};

export const updateCalibration = attrs => (dispatch, getState) => {

  const { id, completed_at, notes } = getState().qaCalibration.calibration;
  const url = `qa_calibrations/${id}`;
  const newAttrs = { ...{ completed_at, notes }, ...attrs };

  return api
    .fetch(dispatch, url, {
      method: 'PUT',
      credentials: 'include',
      headers: {
        'Content-Type': 'application/json',
        'X-CSRF-token': csrfFromDom(),
      },
      body: JSON.stringify(newAttrs),
    })
    .then(([json]) => {
      dispatch(fetchCalibrationSuccess(json));
    });
};

// Reducers

const initialState = {
  calibration: {},
  notes: '',
  loading: true,
  questionAnswers: {},
  selectedOptions: {},
};

export const reducer = (state = initialState, action) => {
  switch (action.type) {
    case FETCH_CALIBRATION_SUCCESS: {
      return {
        ...state,
        loading: false,
        calibration: action.calibration,
        selectedOptions: action.calibration.selected_options,
      };
    }
    case UPDATE_SELECTED_OPTIONS: {
      const selectedOptions = { ...state.selectedOptions, ...action.mapping };
      return { ...state, selectedOptions };
    }
    case FETCH_QUESTION_ANSWERS_SUCCESS: {
      const qId = _.get(_.first(action.answers), 'qa_question_id');

      if (!qId) return state;

      const questionAnswers = {
        ...state.questionAnswers,
        ...{ [qId]: action.answers },
      };
      return { ...state, questionAnswers };
    }
    case CLEAR_CALIBRATION: {
      return initialState;
    }
    default: {
      return state;
    }
  }
};
